// extracted by mini-css-extract-plugin
export var appear = "Notification-module--appear--4JDa8";
export var error = "Notification-module--error--+CHFG";
export var success = "Notification-module--success--XDn11";
export var text = "Notification-module--text--f3pge";
export var wrapper = "Notification-module--wrapper--S92Uo";